import { render, staticRenderFns } from "./InfoBorderIcon.vue?vue&type=template&id=0a5e226d&scoped=true"
import script from "./InfoBorderIcon.vue?vue&type=script&lang=js"
export * from "./InfoBorderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5e226d",
  null
  
)

export default component.exports